import {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import {SupplierReportContext} from '../../context'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import ProfitTrendModal from '../modals/ProfitTrendModal'
import { MIN_DATE_RANGE } from '../../utils'

const SupplierReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)
  const {
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useContext(SupplierReportContext)

  return (
    <>
      <tr>
        <td>{row.supplierName}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&supplier_name=${row.supplierName}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.totalCost}</td>
        <td>{row.totalSale}</td>
        <td>{row.totalProfit}</td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td>{row.contributedProfitPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.supplierName}
          entityName={`Profitability Report - ${row.supplierName}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          entityPerformanceChartData={entityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.supplierName}
          entityName={row.supplierName}
          onProfitTrendIdChange={onProfitTrendIdChange}
          isProfitTrendDataLoading={isProfitTrendDataLoading}
          profitTrendChartData={profitTrendChartData}
          kpiData={profitTrendKpiData}
          weeklyBreakdownData={profitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default SupplierReportRow
